import Vue from 'vue'
import App from './App.vue'
import router from './router'
import packageJson from '../package.json'

// 全局方法
import Client from '@/assets/scripts/client'
import GlobalMixins from '@/assets/scripts/global-mixin'

// 全局组件
import VueClipBoard from 'vue-clipboard2'
import TransformSpecialCodeComp from '@/components/TransformSpecialCode/index.vue'
import NoData from '@/components/NoData/nodata.vue'

// 调试日志
import VConsole from 'vconsole'

import * as filters from '@/filters'
import * as Sentry from '@sentry/vue'

// 移动端适配 && 埋点
import '@/utils/flexible.debug.js'
import '@/utils/flexible-css.debug.js'
import '@/utils/thinking-data.js'

import '@/assets/style/index.scss'
import '@/assets/text/action.css'

import { i18n, loadLanguage, setHtmlDir } from '@/lang/index.js'
import { loadBaseIcon } from '@/assets/packageAssets/packages/index.js'
import { mockLangType, mockApp, mockFlag } from '@/assets/scripts/judge-package-name.js'

import {
  Circle,
  DatetimePicker,
  Dialog,
  Field,
  Icon,
  Image as VanImage,
  Lazyload,
  List,
  Loading,
  NavBar,
  Picker,
  Popover,
  Popup,
  Progress,
  Steps,
  Step,
  Stepper,
  Swipe,
  SwipeItem,
  Tabs,
  Tab,
  Uploader,
} from 'vant'

Vue.component('MyPLabel', TransformSpecialCodeComp)
Vue.component('NoData', NoData)

// vant
Vue.use(Circle)
Vue.use(DatetimePicker)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Icon)
Vue.use(VanImage)
Vue.use(Lazyload, { lazyComponent: true })
Vue.use(List)
Vue.use(Loading)
Vue.use(NavBar)
Vue.use(Picker)
Vue.use(Popover)
Vue.use(Popup)
Vue.use(Progress)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Stepper)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Uploader)

// vue-clipboard
Vue.use(VueClipBoard)

// filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.mixin(GlobalMixins)

Vue.config.productionTip = false

Vue.prototype.$client = Client

Vue.prototype.$sentry = Sentry

// 测试环境
if (process.env.VUE_APP_IS_RELEASE === '0') {
  new VConsole()
}

// 正式环境
if (process.env.VUE_APP_IS_RELEASE === '1') {
  try {
    Sentry.init({
      Vue,
      dsn: 'https://64e5bce043ce5ef0af2b3fa8683c39e7@sentry.goparty.tech/12',
      release: `${process.env.NODE_ENV}@${packageJson.version}`,
      sendDefaultPii: true,
      sampleRate: 0.8,
      environment: process.env.NODE_ENV,
    })
  } catch (err) {
    console.log('try catch err:', err)
  }
}

let useMock = mockFlag
let mockLang = mockLangType
let mockPkg = mockApp

;(async () => {
  // 按需加载语言
  let clientLang = Client.getAppInfoLang() || 'en'
  if (useMock) {
    clientLang = mockLang
  }
  console.log('🚀 ~ initLang:', clientLang)
  await loadLanguage(clientLang)
  setHtmlDir(clientLang)

  // 按需加载分包基础图标
  let appShortName = Client.getPackageShortName() || 'vava'
  if (useMock) {
    appShortName = mockPkg
  }
  console.log('🚀 ~ appShortName:', appShortName)
  await loadBaseIcon(appShortName)

  // 挂载应用
  new Vue({
    router,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')
})()
